export const cardSettingsHistory = {
  items: [
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    },
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    },
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    },
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    },
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    },
    {
      cardNo: '**** **** 1234 5678',
      editDate: '04/02/22 - 14:30',
      actionType: 'Modificare',
      modifiedFieldName: 'Câmp modificat',
      oldValue: '0,00 RON',
      newValue: '0,00 RON'
    }
  ],
  total: 6,
  totalPages: 1
};
